import Cancel24H from '@engineering/icons/cancel24h';
import Like from '@engineering/icons/like';
import Phone from '@engineering/icons/phone';
import { useTranslations } from 'next-intl';
import type { ComponentType, SVGProps } from 'react';
import {
  Badge,
  Badges,
  IconWrapper,
  LongText,
  ShortText,
} from './HomeUspBadges.styles';

type UspKey = 'customers' | 'cancellation' | 'support';

const usps: Array<{
  key: UspKey;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
}> = [
  { key: 'customers', icon: Like },
  { key: 'cancellation', icon: Cancel24H },
  { key: 'support', icon: Phone },
];

/**
 * The USP badge row of the index page variant: icon and a short label.
 * Below xl each badge shows its short text, from xl its long text.
 */
const HomeUspBadges = () => {
  const t = useTranslations('features.stage');

  return (
    <Badges data-testid="home-usp-badges">
      {usps.map(({ key, icon: Icon }) => (
        <Badge key={key} data-usp={key}>
          <IconWrapper aria-hidden="true">
            <Icon />
          </IconWrapper>
          <ShortText>{t(`homeFirstViewport.usps.${key}.short`)}</ShortText>
          <LongText>{t(`homeFirstViewport.usps.${key}.long`)}</LongText>
        </Badge>
      ))}
    </Badges>
  );
};

export { HomeUspBadges };
